module.exports = __webpack_public_path__ + "static/media/icon_1_2.b85c5a2d.svg";